import React, { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import MidiaSocialIcone from "../MidiaSocialIcone";
import { celularMask } from "../InputTextMask";

export function DommusCardAtendimentoDrag({atendimento}){
  const verificaContatoDestino = () => {
    switch (atendimento.meio_comunicacao.slug) {
      case "whatsapp":
      case "voip":
      case "sms":
        return celularMask(atendimento.contato_destino)
      case ("email"):
        return (atendimento?.contato_destino ?? "---")
      case ("chatbot"):
        return ("Chatbot")
      default:
        return (atendimento.contato_destino)
    }
  }
  return (
    <div 
      style={{
        display: "flex",
        flexDirection: "column",
        gap: '5px',
        padding: "10px",
        borderRadius: "10px",
        backgroundColor: "#ffffff50",
        alignItems: "center",
        justifyContent: "center",
        transformOrigin: 'center',
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        border: "3px solid var(--dommus-color)",
        borderStyle: "dashed",
        overflow: "hidden",
      }}
    >
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "-12px",
            width: "0px",
            height: "0px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderRight: "12px solid var(--dommus-color-2)",
          }}
        ></div>
        <span
          style={{
            fontWeight: "600",
          }}
        >
          {atendimento.nome}
        </span>
        <span
          style={{
            fontSize: '0.9rem',
            color: 'gray',
            fontWeight: "600"
          }}
        >
          {verificaContatoDestino()}
        </span>
    </div>
  )
}
